import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../api/Auth';
import { ErrorModal } from '../components/Modal';


interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectPath?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  redirectPath = '/login'
}) => {
  const { isAuthenticated } = useAuth()
  const navigate = useNavigate()

  if (!isAuthenticated) {
    return <ErrorModal
      message={'Unauthorized'}
      onOk={() => {
        navigate(redirectPath)
      }}
    />
  }

  return <>{children}</>;
};

export default ProtectedRoute; 